import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logstreams',
  templateUrl: './logstreams.component.html',
  styleUrls: ['./logstreams.component.scss']
})
export class LogstreamsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
